import { OptionType, Text } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

export const CarrierOption: FC<{ option: OptionType }> = ({ option }) => {
  const { t } = useTranslation('logisticsKR')
  return (
    <div>
      <Text>{option.dto.name}</Text>
      <Text color="secondary" typography="bodySmall">
        {t('common:inn')}: {option.dto.inn}{' '}
        {option.dto.carrier_role.map((role) => t(`carrierRoles.${role}`)).join(', ')}
      </Text>
    </div>
  )
}
